<template>
  <transition @enter="enter">
    <div class="overlay-frame" v-show="$store.state.showOverlay">
      <div class="overlay-frame__container overlay-frame__container--bg">
        <img class="overlay-frame__item" data-src="/img/misc/bg-repeater.png" alt="overlay frame">
        <img class="overlay-frame__item overlay-frame__item--mirrored" data-src="/img/misc/bg-repeater.png" alt="overlay frame">
        <img class="overlay-frame__item" data-src="/img/misc/bg-overlay.png" alt="overlay frame">
        <img class="overlay-frame__item overlay-frame__item--mirrored" data-src="/img/misc/bg-repeater.png" alt="overlay frame">
        <img class="overlay-frame__item" data-src="/img/misc/bg-repeater.png" alt="overlay frame">
      </div>

      <div class="overlay-frame__container overlay-frame__container--ivy">
        <img class="overlay-frame__item" data-src="/img/misc/ivy-repeater.png" alt="overlay frame">
        <img class="overlay-frame__item" data-src="/img/misc/ivy-repeater.png" alt="overlay frame">
        <img class="overlay-frame__item" data-src="/img/misc/ivy-repeater.png" alt="overlay frame">
      </div>

      <img class="overlay-frame__murales overlay-frame__murales--left" data-src="/img/misc/murales-00.png" alt="Murales image">

      <img class="overlay-frame__groundivy overlay-frame__groundivy--left" data-src="/img/misc/groundivy-00.png" alt="Ground-ivy image">
      <img class="overlay-frame__groundivy overlay-frame__groundivy--right" data-src="/img/misc/groundivy-01.png" alt="Ground-ivy image">

      <img class="overlay-frame__washbasin" data-src="/img/misc/washbasin.png" alt="Washbin image">

      <img class="overlay-frame__sunflower overlay-frame__sunflower--tall" data-src="/img/misc/sunflower-01.png" alt="Sunflower image">
      <img class="overlay-frame__sunflower overlay-frame__sunflower--small" data-src="/img/misc/sunflower-00.png" alt="Sunflower image">

      <img class="overlay-frame__stem" data-src="/img/misc/sunflower-stem.png" alt="Sunflower Logo stem image">

      <img
        class="overlay-frame__bgmobile"
        data-src="/img/misc/bg-mobile.png"
        alt="Sunflower Logo stem image"
        data-mobile
      >
    </div>
  </transition>
</template>

<script>
import gsap from 'gsap';
import { isTouchDevice } from '@/scripts/utils';

export default {
  name: 'OverlayFrame',

  data() {
    return {
      assets: {
        dsk: [
          '/img/misc/bg-repeater.png',
          '/img/misc/bg-overlay.png',
          '/img/misc/ivy-repeater.png',
          '/img/misc/sunflower-00.png',
          '/img/misc/sunflower-01.png',
          '/img/misc/murales-00.png',
          '/img/misc/groundivy-00.png',
          '/img/misc/groundivy-01.png',
          '/img/misc/sunflower-stem.png',
          '/img/misc/washbasin.png',
        ],
        mobile: [
          '/img/misc/bg-repeater.png',
          '/img/misc/bg-mobile.png',
        ],
        app: [],
      },
    };
  },

  methods: {
    load() {
      const promises = [];
      const type = (isTouchDevice() && window.innerWidth >= 568) || !isTouchDevice() ? 'dsk' : 'mobile'; // eslint-disable-line

      this.assets[type].forEach((asset) => {
        promises.push(() => {
          const img = new Image();
          img.src = asset;
          return img.decode();
        });
      });

      return Promise.all(promises);
    },
    replaceImgs() {
      const type = (isTouchDevice() && window.innerWidth >= 568) || !isTouchDevice() ? 'dsk' : 'mobile';
      const selector = (isTouchDevice() && window.innerWidth >= 568) || !isTouchDevice() ? 'img:not([data-mobile])' : 'img[data-mobile]';

      [...this.$el.querySelectorAll(selector)].forEach((img) => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });

      if (!this.$inApp) {
        document.body.style.backgroundImage = `url('${this.assets[type][0]}')`;
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundRepeat = 'no-repeat';
        document.body.style.backgroundPosition = 'center center';
      }
    },
    enter(el, done) {
      const ivy = this.$el.querySelector('.overlay-frame__container--ivy');
      const sunflowers = [...this.$el.querySelectorAll('.overlay-frame__sunflower')];
      const murales = this.$el.querySelector('.overlay-frame__murales--left');
      const tl = gsap.timeline({ delay: 0.8, onComplete: done });

      gsap.set(ivy, { xPercent: -50, yPercent: -25 });
      gsap.set(sunflowers, { yPercent: 100 });
      gsap.set(murales, { autoAlpha: 0 });

      tl.addLabel('start')
        .to(ivy, {
          yPercent: -2,
          duration: 2,
          ease: 'elastic.out(0.5, 0.7)',
        }, 'start')
        .to(sunflowers, {
          yPercent: 5,
          stagger: 0.25,
          duration: 2,
          ease: 'elastic.out(0.5, 0.7)',
        }, 'start+=0.5')
        .to(murales, {
          autoAlpha: 1,
          duration: 3,
          ease: 'power2.easeOut',
        }, 'start+=2');
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay-frame {
  @include full(true);

  overflow: hidden;
  pointer-events: none;

  @include mq($until: ipadP, $and: $is-touch-device) {
    &__container,
    img:not([data-mobile]) {
      display: none;
    }
  }

  @include mq($from: ipadP) {
    img[data-mobile] {
      display: none;
    }
  }

  &__container {
    position: absolute;
    top: 0;
    left: 50%;
    width: max-content;

    font-size: 0;

    &--bg {
      height: 100%;
      transform: translateX(-50%);
    }
    &--ivy {
      height: 36.5%;
    }
  }

  &__item {
    display: inline-block;
    position: relative;
    width: auto;
    height: 100%;
    margin: 0 -1px;

    &--mirrored {
      transform: scaleX(-1);
    }
  }

  &__sunflower,
  &__murales,
  &__groundivy,
  &__stem,
  &__washbasin {
    position: absolute;
    bottom: 0;
  }

  &__sunflower {
    &--small {
      right: calc(50% + 20.8vh);
      height: 32%;
    }
    &--tall {
      right: calc(50% + 15.5vh);
      height: 44%;
    }
  }

  &__murales {
    mix-blend-mode: multiply;

    &--left {
      bottom: 38vh;
      right: calc(50% + 30.8vh);
      height: 23%;
    }
  }

  &__groundivy {
    &--left {
      right: calc(50% + 27.8vh);
      height: 65%;
    }
    &--right{
      left: calc(50% + 27vh);
      height: 75%;
    }
  }

  &__stem {
    left: calc(50% + 5.8vh);
    height: 92.5%;
  }

  &__washbasin {
    right: calc(50% + 39.8vh);
    height: 25.5%;
  }

  &__bgmobile {
    position: absolute;
    top: 0;
    left: 50%;
    width: auto;
    height: 100%;

    transform: translateX(-50%);
  }
}
</style>
